import { render } from "./GemMechanism06.vue?vue&type=template&id=004e6b5c&scoped=true"
const script = {}

import "./GemMechanism06.vue?vue&type=style&index=0&id=004e6b5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004e6b5c"]])

export default __exports__